<template>
  <layout background-class="sf-bg-background" class="documents">
    <h1 slot="title" class="documents__title">
      {{ $t("documents-page.page-title") }}
    </h1>

    <documents-list :documents="documents"/>
  </layout>
</template>

<script>
import Layout from '~lib/src/layouts/blank';
import DocumentsList from '~/components/documents-list.vue';

export default {
  components: { DocumentsList, Layout },
  nuxtI18n: {
    paths: {
      ru: '/documenty',
      kg: '/documentter',
    },
  },
  computed: {
    documents() {
      return this.$t('documents-page.documents');
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .blank__title {
  border-top-color: transparent;
}
</style>
